import { render, staticRenderFns } from "./TestVideoCreate.vue?vue&type=template&id=8c155cca&"
import script from "./TestVideoCreate.vue?vue&type=script&lang=js&"
export * from "./TestVideoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports